// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.autofill[data-v-77fdefb0] {\n    background: lightblue;\n}\n.monsterCount[data-v-77fdefb0] {\n    max-width: 40px;\n}\n", ""]);
// Exports
module.exports = exports;
